import React from 'react';

import './Backdrop.css';

const backdrop = props => <div className="backdrop"></div>;

export default backdrop;



// WEBPACK FOOTER //
// ./src/Components/Theme/Backdrop/index.js